import http from "api/https";


// Получить все настройки организации
export const getorganization_settings = (): Promise<any> => {
  return http.get("/OrganizationSetting/GetAll");
};

// Получить настройки по ID организации
export const getorganization_settingsByOrganization = (organization_id: number): Promise<any> => {
  return http.get(`/OrganizationSetting/GetByOrganizationId?organizationId=${organization_id}`);
};

// Получить одну настройку по ID
export const getorganization_setting = (id: number): Promise<any> => {
  return http.get(`/OrganizationSetting/GetOneById?id=${id}`);
};

// Создать новую настройку
export const createorganization_setting = (data: any): Promise<any> => {
  return http.post("/OrganizationSetting/Create", data);
};

// Обновить настройку
export const updateorganization_setting = (data: any): Promise<any> => {
  return http.put(`/OrganizationSetting/Update`, data);
};

// Удалить настройку
export const deleteorganization_setting = (id: number): Promise<any> => {
  return http.remove(`/OrganizationSetting/Delete?id=${id}`,{});
};

// Получить пагинированные настройки
export const getorganization_settingsPaginated = (pageSize: number, pageNumber: number): Promise<any> => {
  return http.get(`/OrganizationSetting/GetPaginated?pageSize=${pageSize}&pageNumber=${pageNumber}`);
};

// Шифр нумерации исходящих документов
export const getDocumentPrefix = (orgId: number): Promise<any> => {
  return http.get(`/OrganizationSetting/GetDocumentPrefix?orgId=${orgId}`);
};

export const setDocumentPrefix = (orgId: number, prefix: string): Promise<any> => {
  return http.post(`/OrganizationSetting/SetDocumentPrefix`, { org_id: orgId, prefix });
};

export const setDocumentCounter = (orgId: number, counter: number): Promise<any> => {
  return http.post(`/OrganizationSetting/SetDocumentCounter`, { org_id: orgId, counter });
};

export const getDocumentPrefixByApprovalRequest = (approvalRequestId: number): Promise<any> => {
  return http.get(`/OrganizationSetting/GetDocumentPrefixByApprovalRequest?approvalRequestId=${approvalRequestId}`);
};